import { render, staticRenderFns } from "./Pixels.vue?vue&type=template&id=7f9cb500&"
import script from "./Pixels.vue?vue&type=script&lang=js&"
export * from "./Pixels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports